import { Fragment } from 'react';

import type { OAISchema } from '~/types/openapi';

import EventBanner from '../../components/EventBanner';
import EventTitle from '../../components/EventTitle';
import ShowcaseRenderer from '../../components/ShowcaseRenderer';

type Props = {
  items: OAISchema['PlacementEventResponse']['items'];
};

export function EventPlacementList({ items }: Props) {
  return (
    <>
      {items?.map((item) => {
        return (
          <Fragment key={item.code}>
            {item.itemType === 'BANNER' ? (
              <>
                {item.imageUrl && (
                  <EventBanner
                    imageUrl={item.imageUrl}
                    landingUrl={item.landingUrl}
                  />
                )}
              </>
            ) : (
              <>
                {item.title && <EventTitle title={item.title} />}
                {item.showcaseType && item.displayType && item.code && (
                  <ShowcaseRenderer
                    type={item.showcaseType}
                    displayType={item.displayType}
                    code={item.code}
                  />
                )}
              </>
            )}
          </Fragment>
        );
      })}
    </>
  );
}
